import './rolesGroup.css'
import React, { useContext } from 'react';
import { GridList } from '@material-ui/core';
import RoomProvider from 'components/Provider/RoomProvider';
import gfGroupTypes from 'others/game/gfGroupTypes';
import { decRole } from 'others/game/utils';

const requestImageFile = require.context('../../assets/roles', true, /.png$/);

function RoleItem({ role, isSeleted, onSelect }){
    const data = gfGroupTypes.role(role);
    return(
        <div 
            className={`role_item ${isSeleted && 'selected'}`} 
            onClick={()=>onSelect(data)}
        >
            <img 
                className='role_img'
                src={requestImageFile(`./${role.role.img}.png`).default} alt='role_icon' 
            />
            <div className='role_badge_container'>
                <p className='role_badge_text'>{`×${role.count}`}</p>
            </div>
            <p className='role_title'>{role.role.title}</p>

        </div>
    );
}

function RolesGroup({ onRoleSelected, selectedRole, roleToUse, readOnly, showItemConter = true }) {
    const { room } = useContext(RoomProvider);

    if(!room.gfBox?.availableRoles){
        return <></>;
    }

    const roles = decRole(room.gfBox.availableRoles, roleToUse);

    var totalRolesCount = 0;
    for(let r of roles) {
        totalRolesCount += r.count;
    }
    

    return (
        <div id='roleGroup_container' className='roleGroup'>
            {showItemConter && <p className='godfatherbox_itemCounter'>Il reste {totalRolesCount} rôle(s)</p>}
            <GridList cellHeight={64} cols={2}>
               { roles.map(role=>(
                   <RoleItem 
                        role={role} 
                        key={role.role.name} 
                        isSeleted={role.role.name == selectedRole?.name}
                        onSelect={readOnly ? ()=>{} : onRoleSelected}
                    />
               )) }
            </GridList>
        </div>
    );
}

export default RolesGroup;